import {
  IndicateurMethodeValues,
  IndicatorDimensionsValues,
  IndicatorDonneeValues,
  IndicatorPossibleFilters,
  IndicatorRestitutionValues,
} from '@pages/pilotage-rh/indicators/indicator-types';

/**
 * Crée un mapping valeur -> label à partir d'un tableau d'options
 */
const createMapping = (values: Array<{label: string; value: string}>): Record<string, string> => {
  return values.reduce(
    (acc, item) => {
      acc[item.value] = item.label;
      return acc;
    },
    {} as Record<string, string>,
  );
};

/**
 * Mappings pour les différents champs de l'indicateur
 */
export const FIELD_MAPPINGS = {
  dimensions: createMapping(IndicatorDimensionsValues),
  chartTypes: createMapping(IndicatorRestitutionValues),
  methods: createMapping(IndicateurMethodeValues),
  donnees: createMapping(IndicatorDonneeValues),
  possibleFilters: createMapping(IndicatorPossibleFilters),
} as const;

/**
 * Champs à ignorer lors de la détection des changements
 */
export const SKIP_FIELDS = ['uuid', 'modifiedAt', 'order', 'ordre', 'baseIndicatorUuid', 'modifiable', 'fixed'];

/**
 * Détermine le mapping approprié pour un champ donné
 */
export const getMappingForField = (fieldPath: string): Record<string, string> | null => {
  if (fieldPath.includes('chartType') || fieldPath.includes('ChartTypes')) return FIELD_MAPPINGS.chartTypes;
  if (fieldPath.includes('methode')) return FIELD_MAPPINGS.methods;
  if (fieldPath.includes('donnee') || fieldPath.includes('Donnees')) return FIELD_MAPPINGS.donnees;
  if (fieldPath.includes('possibleFilters')) return FIELD_MAPPINGS.possibleFilters;
  if (fieldPath.match(/\.[xyz]$/) || fieldPath.includes('possible')) return FIELD_MAPPINGS.dimensions;
  return null;
};
